import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavController } from 'ionic-angular';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/takeWhile';
import { SessionPage } from '../session/session';
import { Settings, SettingsProvider } from './../../provider/settings-service';

@Component({
    selector: 'page-settings',
    templateUrl: 'settings.html'
})
export class SettingsPage {

    public settings: Settings;
    public formGroup: FormGroup;
    public refsize = 50; // 50 mm

    constructor(
        private settingsProvider: SettingsProvider,
        private fb: FormBuilder,
        private navCtrl: NavController
    ) {
        this.settingsProvider.load().subscribe(settings => {
            console.log(settings);
            this.settings = settings;
            this.formGroup = this.fb.group({
                durchlaeufe: [settings.durchlaeufe, [Validators.required, Validators.min(0)]],
                anschlaege: [settings.anschlaege, [Validators.required, Validators.min(0)]],
                rate: [settings.rate, [Validators.required, Validators.min(0.3), Validators.max(10)]],
                realsizex: [settings.realsizex, [Validators.required, Validators.min(0)]],
                realsizey: [settings.realsizey, [Validators.required, Validators.min(0)]]
            });
        });
    }

    public ionViewDidLeave() {
        this.save();
    }

    public saveClicked(): void {
        this.save();
        if (this.navCtrl.length() > 1) {
            this.navCtrl.pop();
        } else {
            this.navCtrl.setRoot(SessionPage);
        }
    }

    public save(): void {
        if (this.formGroup.valid) {
            this.settingsProvider.settings.durchlaeufe = this.formGroup.get('durchlaeufe').value;
            this.settingsProvider.settings.anschlaege = this.formGroup.get('anschlaege').value;
            this.settingsProvider.settings.rate = this.formGroup.get('rate').value;
            this.settingsProvider.settings.realsizex = this.formGroup.get('realsizex').value;
            this.settingsProvider.settings.realsizey = this.formGroup.get('realsizey').value;
            this.settingsProvider.save();
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts